<template>
    <div v-if="isReady" class="background-inbox-card" v-resize="onResize">
        <v-row no-gutters class="standard-row font-for-header-tabs d-flex justify-space-between" align="center" style="font-weight: 700; padding: 21px 4.4% 0% 2.5%;">
            <v-col cols="11" sm="11" md="auto" lg="auto">
                <v-slide-group show-arrows mandatory v-model="permissionTabs" color="black">
                    <v-slide-item v-slot="{ active, toggle }" value="inbox_all" >
                        <v-btn :input-value="active" active-class="select-header-tabs" class="font-for-header-tabs" @click="toggle" height="52" depressed rounded text>
                            All
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="inbox_purchase" >
                        <v-btn :input-value="active" active-class="select-header-tabs" class="font-for-header-tabs" @click="toggle" height="52" depressed rounded text>
                            จัดซื้อ 
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-col>
            <v-col cols="1" sm="1" v-if="windowSize.x < 960" class="d-flex justify-end">
                <template>
                    <v-menu offset-y>
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReport()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Download Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> 
                    </v-menu>
                </template>
            </v-col>
            <v-col v-else md="auto" lg="">
                <span class="d-flex mt-5 mt-sm-0" :class="windowSize.x <= 600? 'justify-center': 'justify-end'">
                    <v-btn rounded color="#FFFFFF"  class="download-report-inbox-btn" @click="goToDownloadReport()" height="53" width="193" style="font-weight: 700; font-size: 15px; border: 2px solid #0B68D6">
                        <v-icon style=" color: #0B68D6; font-size: 55px; margin-left: -40px;" class="mdi mdi-arrow-down-bold-circle"></v-icon>
                        <span align="center" style="color: #0B68D6; font-size: 20px;">Download</span>
                    </v-btn>
                </span>
            </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" align="center" style="font-weight: 700; padding: 20px 4.4% 0% 4.4%;">
            <v-row no-gutters class="standard-row font-theme" align="center">
                <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 15px;" class="ml-4 ml-sm-0">
                    ค้นหา
                </v-col>
                <v-col cols="" sm="" md="4" lg="4" class="ml-sm-8">
                    <v-text-field dense outlined hide-details color="black" background-color="white" height="42" class="font-theme custom-search-text-field" v-model="holdKeyword" @input="!holdKeyword? checkRowsAndPageBeforeSearch(holdKeyword): ''" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)">
                        <template v-slot:append v-if="windowSize.x < 600">
                            <v-btn icon style="margin-top: 3px" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                                <v-icon size="38">mdi-magnify</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-col>
                <v-col v-if="windowSize.x > 600" sm="auto" md="auto" lg="auto" class="ml-5">
                    <v-btn rounded color="#0B68D6" class="white--text" height="42" width="125" style="font-weight: 700; font-size: 15px; box-shadow: none;" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                        Search
                    </v-btn>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row font-theme pt-5 display-pc-only" align="center">
                <v-slide-group show-arrows mandatory v-model="documentStatus">
                    <v-slide-item v-slot="{ active, toggle }" value="">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#3B639F" :content="countTransaction[''].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                เอกสารทั้งหมด
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="W">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#7FE0DA  " :content="countTransaction['W'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                รอดำเนินการ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="N">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#EEC120" :content="countTransaction['N'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                รอ PO
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="Y">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#74CA5F" :content="countTransaction['Y'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                อนุมัติ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                    <v-slide-item v-slot="{ active, toggle }" value="R">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#EC9589" :content="countTransaction['R'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content">
                                ปฎิเสธ
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                     <v-slide-item v-slot="{ active, toggle }" value="C">
                        <v-btn :input-value="active" active-class="selected-status-tab" class="document-status-tab" @click="toggle" height="51" depressed rounded text>
                            <v-badge inline color="#BDBDBD" :content="countTransaction['C'].toString()" style="font-weight: 700; font-size: 15px;" class="custom-badge-content general-badge-color">
                                ยกเลิก
                            </v-badge>
                        </v-btn>
                    </v-slide-item>
                </v-slide-group>
            </v-row>
            <v-row no-gutters class="standard-row pt-4 pt-sm-7 display-mobile-only" align="center">
                <v-col cols="12" style="font-size: 15px;" class="ml-4">
                    สถานะเอกสาร
                </v-col>
                <v-col cols="12">
                    <v-select :items="statusDocument" hide-details outlined dense height="42" item-text="status" item-value="value" v-model="documentStatus" append-icon="mdi-chevron-down" background-color="white" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="custom-search-dropdown">
                        <template v-slot:item="data">
                            <v-list-item-content>
                                <v-list-item-title class="font-theme" style="font-size: 15px; font-weight: 700; line-height: 30px;">{{ data.item.status }}</v-list-item-title>
                            </v-list-item-content>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <v-row no-gutters class="standard-row mt-4 mb-7">
                <v-data-table 
                    :headers="headers" 
                    range 
                    :items="myTransactions" 
                    fixed-header 
                    class="elevation-0 list-data-table" 
                    style="width: 100%" :options.sync="optionsTransaction" 
                    :server-items-length="countTransaction[documentStatus]" 
                    :footer-props="{ 'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า' }" 
                    mobile-breakpoint="601"
                    @click:row="goToDocumentDetail($event._id,$event.account_id)"
                >
                    <template v-slot:[`item.detail_doc`] = "{ item }">
                        <v-tooltip top>
                            <template v-slot:activator="{ on }">
                                <v-btn v-show="item.account_id == raDetail.account_id" icon v-on="on"  @click.stop="goToDocumentDetail(item._id,item.account_id )">
                                    <svg width="22" height="22" fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> 
                                        <path fill-rule="evenodd" d="M14.8024118,6.44526791 L8.69610276,12.549589 C8.29095108,12.9079238 8.04030835,13.4092335 8,13.8678295 L8,16.0029438 L10.0639829,16.004826 C10.5982069,15.9670062 11.0954869,15.7183782 11.4947932,15.2616227 L17.556693,9.19972295 L14.8024118,6.44526791 Z M16.2168556,5.0312846 L18.9709065,7.78550938 L19.8647941,6.89162181 C19.9513987,6.80501747 20.0000526,6.68755666 20.0000526,6.56507948 C20.0000526,6.4426023 19.9513987,6.32514149 19.8647932,6.23853626 L17.7611243,4.13485646 C17.6754884,4.04854589 17.5589355,4 17.43735,4 C17.3157645,4 17.1992116,4.04854589 17.1135757,4.13485646 L16.2168556,5.0312846 Z M22,13 L22,20 C22,21.1045695 21.1045695,22 20,22 L4,22 C2.8954305,22 2,21.1045695 2,20 L2,4 C2,2.8954305 2.8954305,2 4,2 L11,2 L11,4 L4,4 L4,20 L20,20 L20,13 L22,13 Z M17.43735,2 C18.0920882,2 18.7197259,2.26141978 19.1781068,2.7234227 L21.2790059,4.82432181 C21.7406843,5.28599904 22.0000526,5.91216845 22.0000526,6.56507948 C22.0000526,7.21799052 21.7406843,7.84415992 21.2790068,8.30583626 L12.9575072,16.6237545 C12.2590245,17.4294925 11.2689,17.9245308 10.1346,18.0023295 L6,18.0023295 L6,17.0023295 L6.00324765,13.7873015 C6.08843822,12.7328366 6.57866679,11.7523321 7.32649633,11.0934196 L15.6953877,2.72462818 C16.1563921,2.2608295 16.7833514,2 17.43735,2 Z"></path> </g>
                                    </svg>
                                </v-btn>
                            </template>
                            <span class="font-theme">รายละเอียดเอกสาร</span>
                        </v-tooltip>
                    </template>
                    <template slot="no-data">
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:no-results>
                        <v-alert class="text-center d-flex justify-center">
                            ไม่พบข้อมูล
                        </v-alert>
                    </template>
                    <template v-slot:[`footer.page-text`]="items">
                        {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                    </template>
                    <template v-slot:[`item.sale_document`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.sale_document || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.cs_document_id`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.cs_document_id || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.group_service`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.group_service || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.vendor_name`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.vendor_name || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.qt_vendor`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.qt_vendor || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.qt_value`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.qt_value || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.service_name`]="{ item }">
                        <div v-for="(el,index) in item.list" :key="index">
                            {{ el.service_name || '–' }}
                        </div>
                    </template>
                    <template v-slot:[`item.document_status`]="{ item }">
                        <div v-if="item.document_status == 'Y'"><v-icon color="#74CA5F">mdi-circle-medium</v-icon>เสร็จสิ้น</div>
                        <div v-if="item.document_status == 'N'"><v-icon color="#EEC120">mdi-circle-medium</v-icon>รอ PO</div>
                        <div v-if="item.document_status == 'W'"><v-icon color="#7FE0DA">mdi-circle-medium</v-icon>รอดำเนินการ</div>
                        <div v-if="item.document_status == 'R'"><v-icon color="#EC9589">mdi-circle-medium</v-icon>ปฏิเสธ</div>
                        <div v-if="item.document_status == 'C'"><v-icon color="#BDBDBD">mdi-circle-medium</v-icon>ยกเลิก</div>
                    </template>
                    <template v-slot:[`item.po_status`] = "{ item }">
                        <span v-if="item.po_status =='C'" style="color: #DA8EF2;">PO Cancel</span>
                        <span v-else-if="item.po_status =='W'" style="color: #EEC120;">Waiting</span>
                        <span v-else-if="item.po_status =='Y'" style="color: #1BDE3A;">Success</span>
                    </template>
                    <template v-slot:[`item.po_number`]="{ item }">
                        <div>
                            {{ item.po_number || '–' }}
                        </div>
                    </template>
                </v-data-table>
            </v-row>
        </v-row>
        <ConfirmCopyDocument />
        <DownloadReportModal />
    </div>
</template>

<script>
import { MainFunction } from '@/functions/mainFunction.js'
import { EventBus } from '../EventBus'
import ConfirmCopyDocument from '../components/ConfirmCopyDocument.vue'
import DownloadReportModal from '../components/DownloadReportModal.vue'
    export default {
        components: {
            ConfirmCopyDocument,
            DownloadReportModal
        },
        data: () => ({
            selectedDoctype: {
                "name": "ทั้งหมด",
                "pr_id": "00",
                "_id": ""
            },
            statusDocument: [
                { status: 'เอกสารทั้งหมด', value: ''},
                { status: 'รอPO', value: 'N'},
                { status: 'รอดำเนินการ', value: 'W'},
                { status: 'อนุมัติ', value: 'Y'},
                { status: 'ปฎิเสธ', value: 'R'},
            ],
           headers: [
                { text: 'No', value: 'document_id', align: 'center', sortable: false, width: '5%' },
                { text: 'SO', value: 'sale_document', align: 'center', sortable: false, width: '6%' },
                { text: 'CS', value: 'cs_document_id', align: 'center', sortable: false, width: '5%' },
                { text: 'Type', value: 'group_service', align: 'center', sortable: false, width: '6%' },
                { text: 'Vendor Name', value: 'vendor_name', align: 'center', sortable: false, width: '11%' },
                { text: 'QT Vendor', value: 'qt_vendor', align: 'center', sortable: false, width: '6%' },
                { text: 'QT Value', value: 'qt_value', align: 'center', sortable: false, width: '6%' },
                { text: 'Service', value: 'service_name', align: 'center', sortable: false, width: '15%' },
                { text: 'วันที่', value: 'updated_at', align: 'center', sortable: false, width: '6%' },
                { text: 'ผู้สร้าง',value: 'full_name_sender',align: 'center', sortable: false, width: '10%' },
                { text: 'สถานะ', value: 'document_status',align: 'center', sortable: false, width: '8%' },
                { text: 'PO', value: 'po_number', align: 'center', sortable: false, width: '8%' },
                { text: 'PO Status',value: 'po_status',align: 'center', sortable: false, width: '6%' },
                { text: '',value: 'detail_doc', align: 'center', sortable: false, width: '2%' }
            ],
            myPermission:'inbox_all',
            permissionTabs: localStorage.getItem('permissionTabs') || 'inbox_all',
            optionsTransaction: { 
                page: 1,
                itemsPerPage: 20
            },
            windowSize: { x: 0, y: 0 },
            trigRowPerPage: false,
            countTransaction: {},
            dateRangeFilter: [],
            myTransactions: [],
            isChangeTab: false,
            documentStatus: '',
            callApiPending: 0,
            documentType: [],
            holdKeyword: '',
            dateMenu: false,
            isReady: false,
            keyword: '',
        }),
        watch: {
            "optionsTransaction.page"(newValue) {
                if (newValue != 1 || !this.isChangeTab) {
                    this.getTransaction()
                    this.trigRowPerPage = true
                }
            },
            "optionsTransaction.itemsPerPage"() {
                if (!this.trigRowPerPage) {
                    this.optionsTransaction.page = 1
                    this.getTransaction()
                }
            },
            "documentStatus"() {
                this.optionsTransaction.page = 1
                this.getTransaction()
                this.isChangeTab = true
            },
            permissionTabs(value) {
                if (value) {
                    localStorage.setItem('permissionTabs', value);
                }
                this.checkPageForGetTransaction();
            },
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            }
        },
        computed: {
            dateRangeShow() {
                let formatDate = ''
                if (this.dateRangeFilter.length === 2) {
                    formatDate = this.dateRangeFilter.map(element => MainFunction.shortDate(element)).join('  —  ')
                } else {
                    formatDate = ''
                }
                return formatDate
            },
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            },
            raDetail() {
                return this.$store.state.raDetail
            },
            permissionInbox() {
                return this.$store.state.permissionInbox
            }
        },
        mounted () {
            const indexPermission = this.permissionInbox?.findIndex(e => e.inbox === "บัญชี") || null
            if (indexPermission >= 0) {
                const tempDataPermission = this.permissionInbox[indexPermission]
                this.permissionInbox.splice(indexPermission, 1)
                this.permissionInbox.push(tempDataPermission)
            }
            this.onResize()
            this.getTransaction()
            this.$store.commit('setSelectedPermissionInbox', null)
        },
        methods: {
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            checkRowsAndPageBeforeSearch(params) {
                if (this.keyword === params) {
                    return
                }
                this.keyword = params.trim()
                this.checkPageForGetTransaction()
            },
            async getTransaction() {
                try {
                    this.callApiPending++
                    const countTransactions = {
                        baseURL : this.$api_url,
                        url     : `/cs_to_po/api/v1/run_po_count_status?tax_id=${this.selectedBiz.tax_id}&document_status=${this.documentStatus || ''}&keyword=${this.keyword}&inbox=${this.permissionTabs === 'inbox_all' ? 'all' : 'จัดซื้อ'}`,
                        method  : 'GET'
                    }
                    const searchTransactions = {
                        baseURL : this.$api_url,
                        url     : `/cs_to_po/api/v1/run_po_search?tax_id=${this.selectedBiz.tax_id}&document_status=${this.documentStatus || ''}&keyword=${this.keyword}&offset=${(this.optionsTransaction.page - 1) * this.optionsTransaction.itemsPerPage || 0}&limit=${this.optionsTransaction.itemsPerPage}&inbox=${this.permissionTabs === 'inbox_all' ? 'all' : 'จัดซื้อ'}`,
                        method  : 'GET'
                    }
                    const data = await Promise.all([ this.axios(countTransactions), this.axios(searchTransactions) ])
                    this.countTransaction = {
                        'Y' : data[0].data.data.approved  || 0,
                        'C' : data[0].data.data.cancel   || 0,
                        'N' : data[0].data.data.waiting_po  || 0,
                        'R' : data[0].data.data.rejected   || 0,
                        'W'  : data[0].data.data.waiting || 0,
                        ''  : data[0].data.data.total    || 0
                    }
                    this.myTransactions = []
                    if (data[1].data.data.length) {
                        for (let i = 0; i < data[1].data.data.length; i++) {
                            data[1].data.data[i].updated_at = MainFunction.shortDate(data[1].data.data[i].updated_at)
                            this.myTransactions.push(data[1].data.data[i])
                        }
                        $(".list-data-table.v-data-table > .v-data-table__wrapper").scrollTop(0)
                    }  
                    
                } catch (error) {
                    this.myTransactions   = []
                    this.countTransaction = {
                        'Y': 0,
                        'C': 0,
                        'N': 0,
                        'R': 0,
                        'W': 0,
                        '' : 0
                    }
                    let alertMessage = 'กรุณาลองใหม่อีกครั้ง'
                    if (error.response.data.message === 'permission denined' || error.response.data.message === 'view permission denined') alertMessage = 'ไม่มีสิทธิ์การเข้า'
                    this.alert(alertMessage, 'Fail', 'error')
                    console.log(error)
                } finally {
                    this.callApiPending--
                    this.isChangeTab = false
                    this.trigRowPerPage = false
                    if (!this.callApiPending) {
                        this.isReady = true
                    }
                }
            },
           
            // async getDoctypeAndPermission() {
            //     try {
            //         const getDocType = {
            //             baseURL : this.$api_url,
            //             url     : `/document_type/api/v1/get_document_type?tax_id=${this.selectedBiz.tax_id}`,
            //             method  : 'GET'
            //         }
            //         const getPermission = {
            //             baseURL : this.$api_url,
            //             url     : `/permission/api/v1/inbox_permission?tax_id=${this.selectedBiz.tax_id}`,
            //             method  : 'GET'
            //         }
            //         this.callApiPending++
            //         const data = await Promise.allSettled([ this.axios(getDocType), this.axios(getPermission) ])
            //         if (data[0].status === 'fulfilled' && data[0].value.data.status && data[0].value.data.data.length) {
            //             this.documentType = data[0].value.data.data
            //             this.documentType.unshift({
            //                 name : "ทั้งหมด",
            //                 pr_id: "00",
            //                 _id  : ""
            //             })
            //         } else {
            //             this.documentType = []
            //         }
            //         if (data[1].status === 'fulfilled' && data[1].value.data.status && data[1].value.data.data.length) {
            //             this.myPermission = []
            //             for (let i = 0; i < data[1].value.data.data.length; i++) {
            //                 this.myPermission.push({
            //                     inbox   : data[1].value.data.data[i].inbox            || '',
            //                     dept_id : data[1].value.data.data[i].dept_id.join('') || ''
            //                 })
            //             }
            //         } else {
            //             this.myPermission = {}
            //         }
            //     } catch (error) {
            //         console.log(error);
            //     } finally {
            //         this.callApiPending--
            //         if (!this.callApiPending) {
            //             this.isReady = true
            //         }
            //     }
            // },
            goToDocumentDetail(id,account_id) {
                // if(account_id ==  this.raDetail.account_id || this.permissionTabs =='inbox_purchase'){
                    this.$store.commit('setTransactionId', id)
                    this.$store.commit('setSelectedPermissionInbox',this.permissionTabs)
                    this.$router.push({ path: '/inbox_cs_po/purchase_detail' })
                // }
            },

            colorIconFailDwf(status) {
                let colorIcon = ''
                switch (status) {
                    case 'c':
                        colorIcon = '#2A2E3B'
                        break;
                    case 'r':
                        colorIcon = '#E08D8D'
                        break;
                    case 'y':
                        colorIcon = '#1BDE3A'
                        break;
                    default:
                        colorIcon = 'black'
                        break;
                }
                return colorIcon
            },
            
            searchTransactionByDate() {
                this.dateMenu = false
                this.dateRangeFilter = this.dateRangeFilter.sort()
                this.checkPageForGetTransaction()
            },
            goToDownloadReport(){
                const aboutReport = {
                    url        : '/report/api/v1/export_report_inbox_cs_to_po',
                    from       : 'inbox_cs_po'
                }
                EventBus.$emit('openDownloadReportModal', aboutReport)
            },
            checkPageForGetTransaction() {
                if (this.optionsTransaction.page === 1) {
                    this.getTransaction()
                } else {
                    this.optionsTransaction.page = 1
                }
            },
            alert(title = '', text = 'Fail', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            }
        }
    }
</script>

<style>
    .background-inbox-card {
        background: #FFFFFF !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        border-radius: 23px;
        margin: 60px 2% 3.61% 2%;
    }

    .tab-detail {
        font-size: 36px;
        font-weight: 700;
        color: white !important;
    }

    .font-for-header-tabs {
        font-family: 'Sarabun', sans-serif;
        font-size: calc(100% + 0.56vw) !important;
        font-weight: 700;
        letter-spacing: 2px;
        color: #8D8D8D !important;
    }

    .font-for-header-tabs:before {
        background: transparent !important;
    }

    .document-status-tab:before {
        background: transparent !important;
    }

    .select-header-tabs {
        background: #73737380 !important;
        color: black !important;
    }

    .tab-detail-active {
        background: rgba(255, 254, 254, 0.5) !important;
        border-radius: 30px;
        opacity: 1;
        color: black !important;
    }

    .v-btn {
        text-transform: inherit;
    }

    .custom-search-text-field {
        border-radius: 30px !important;
    }

    .custom-search-dropdown {
        border-radius: 30px !important;
    }

    .custom-search-dropdown.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .custom-search-text-field.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .custom-search-dropdown .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon {
        margin-top: 8px;
    }

    .custom-badge-content {
        letter-spacing: 0 !important;
    }

    .clear-icon-date-picker .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--clear {
        margin-top: 8px;
    }

    .custom-badge-content .v-badge__wrapper span {
        height: 27px;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 8px;
        border-radius: 20px;
    }

    .custom-badge-content .v-badge__wrapper {
        margin-right: 0px;
        margin-left: 10px;
    }

    .selected-status-tab {
        background-color: #D9D9D9;
    }

    .list-data-table .v-data-table__wrapper table .v-data-table-header tr th {
        background-color: #F1F0F0;
        height: 56px;
        box-shadow: none;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover {
        cursor: pointer;
    }

    .list-data-table .v-data-table__wrapper table tbody tr td {
        font-size: 10px;
        border-bottom: none !important;
    }

    .list-data-table {
        border-radius: 10px;
        overflow-y: auto;
    }

    .list-data-table thead th:first-child {
        border-radius: 5px 0 0 0;
    }

    .list-data-table thead th:last-child {
        border-radius: 0 5px 0 0;
    }

    .list-data-table .v-data-table__wrapper table thead tr th {
        font-size: 12px;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 259px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .list-data-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #F7F6F6;;
    }

    .list-data-table > .v-data-table__wrapper > table > thead > tr > th {
        color: black !important;
    }

    .detail-date-picker-inbox .theme--light.v-date-picker-table th {
        color: black !important;
        background-color: #E3E3E35E !important;
        font-size: 12px !important;
    }

    .detail-date-picker-inbox .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .custom-search-dropdown.v-select.v-input--dense .v-select__selection--comma  {
        margin-left: 5px;
    }

    .custom-search-dropdown.v-text-field:not(.v-text-field--single-line) input {
        margin-left: 5px;
        line-height: 30px;
    }

    .custom-search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        margin-left: 5px;
        margin-right: 5px;
    }

    .custom-search-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .custom-search-dropdown .v-input__control .v-input__slot .v-select__slot .v-select__selections {
        line-height: 30px;
    }

    .download-report-inbox-btn {
        border-radius: 30px;
        box-shadow: none;
    }

    @media only screen and (max-width: 600px) {

        .list-data-table .v-data-table__wrapper table tbody tr td:last-child {
            border-bottom: 3px solid rgba(0, 0, 0, 0.12) !important;
        }

        .list-data-table .v-data-table__wrapper table tbody tr:last-child td {
            border-bottom: none !important;
        }

        .list-data-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td:last-child {
            border-bottom: none !important;
        }

        .list-data-table .v-data-table__empty-wrapper {
            display: flex;
            justify-content: center;
        }
    }
</style>